import React from "react";
import { AIOrderDraft } from "@/components/AIOrderDraft";

export default function AIOrder() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid="ai-order-page">
      <h1 className="font-display text-3xl sm:text-4xl font-bold">Order by describing it</h1>
      <p className="text-muted-foreground mt-1 mb-6">Type your list the way you'd say it. Smart AI finds each item in the real SHOP NOW catalogue; you confirm before anything reaches your cart.</p>
      <AIOrderDraft />
    </div>
  );
}
